import type { FC } from 'react';
import { RenderForm } from '../../../../../app/infrastructure/form';
import { useContactPanel } from './useContactPanel';
import './styles.scss';

export const ContactPanel: FC = () => {
  const {
    t,
    contactRows,
    form,
    isSubmitted,
    confirmHandler,
    isSubmitting,
    schema,
  } = useContactPanel();

  return (
    <section className="contact-panel" id="contacts">
      <h3 className="contact-panel__title text-center">
        {t('contact-panel.title')}
      </h3>
      <div className="contact-panel__form">
        <div className="contact-panel__form-left">
          <h4 className="contact-panel__title">
            {t('contact-panel.set-form-title')}
          </h4>
          <span className="contact-panel__title-ext mb-30">
            {t('contact-panel.subtitle')}
          </span>
          <form
            onSubmit={(event) => {
              event.preventDefault();
              confirmHandler();
            }}
          >
            <RenderForm
              schema={schema}
              form={form}
              isSubmitted={isSubmitted}
              t={t}
            />
            <div className="btn-group">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={isSubmitting}
              >
                {isSubmitting
                  ? t('contact-panel.sending')
                  : t('contact-panel.button')}
              </button>
            </div>
          </form>
        </div>
        <div className="contact-panel__form-right w-100">
          <div>
            <ul className="mt-50 contact-panel__coord">
              {contactRows.map((row) => (
                <li key={row.kind} className="mb-16 pl-40">
                  <span className={`icon icon-${row.kind}`} />
                  {row.telHref ? (
                    <a href={`tel:${row.telHref}`}>{row.display}</a>
                  ) : row.mailto ? (
                    <a href={`mailto:${row.mailto}`}>{row.display}</a>
                  ) : (
                    row.display
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactPanel;
